var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-keypoint",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "cw-keypoint-content",
                      class: ["cw-keypoint-" + _vm.currentColor],
                    },
                    [
                      _vm.currentIcon
                        ? _c("studip-icon", {
                            attrs: {
                              size: "48",
                              shape: _vm.currentIcon,
                              role: _vm.currentRole,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "cw-keypoint-sentence",
                        },
                        [_vm._v(_vm._s(_vm.currentText))]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-4",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Merksatz")) +
                                  "\n                    "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentText,
                                    expression: "currentText",
                                  },
                                ],
                                staticClass: "cw-keypoint-set-content",
                                attrs: {
                                  type: "text",
                                  name: "cw-keypoint-content",
                                  spellcheck: "true",
                                },
                                domProps: {
                                  value: _vm.currentText,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) return
                                    _vm.currentText = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "col-2",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Farbe")) +
                                  "\n                    "
                              ),
                              _c("studip-select", {
                                attrs: {
                                  options: _vm.colors,
                                  label: "name",
                                  clearable: false,
                                  reduce: function reduce(option) {
                                    return option.icon
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "open-indicator",
                                      fn: function fn(selectAttributes) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._b(
                                              {},
                                              "span",
                                              selectAttributes,
                                              false
                                            ),
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_1down",
                                                  size: 10,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "no-options",
                                      fn: function fn() {
                                        return [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Es steht keine Auswahl zur Verfügung."
                                                )
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function fn(option) {
                                        return [
                                          _c("span", {
                                            staticClass: "vs__option-color",
                                            style: {
                                              "background-color": option.hex,
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(option.name)),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function fn(option) {
                                        return [
                                          _c("span", {
                                            staticClass: "vs__option-color",
                                            style: {
                                              "background-color": option.hex,
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(option.name)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4082607289
                                ),
                                model: {
                                  value: _vm.currentColor,
                                  callback: function callback($$v) {
                                    _vm.currentColor = $$v
                                  },
                                  expression: "currentColor",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "col-2",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Icon")) +
                                  "\n                    "
                              ),
                              _c("studip-select", {
                                attrs: {
                                  options: _vm.icons,
                                  clearable: false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "open-indicator",
                                      fn: function fn(selectAttributes) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._b(
                                              {},
                                              "span",
                                              selectAttributes,
                                              false
                                            ),
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_1down",
                                                  size: 10,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "no-options",
                                      fn: function fn() {
                                        return [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Es steht keine Auswahl zur Verfügung."
                                                )
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function fn(option) {
                                        return [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: option.label,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "vs__option-with-icon",
                                            },
                                            [_vm._v(_vm._s(option.label))]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function fn(option) {
                                        return [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: option.label,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "vs__option-with-icon",
                                            },
                                            [_vm._v(_vm._s(option.label))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1212825753
                                ),
                                model: {
                                  value: _vm.currentIcon,
                                  callback: function callback($$v) {
                                    _vm.currentIcon = $$v
                                  },
                                  expression: "currentIcon",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Informationen zum Merksatz-Block"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }